import React, { useReducer, useState } from 'react';

import "./LegalsWizard.scss";
import { Block } from "@randajan/jet-react/dom/block";

import { usePopSelf } from '@randajan/jet-react/dom/modal';
import { LegalSlide } from './LegalSlide/LegalSlide';
import { Wizard } from '../../../elements/Wizard/Wizard';

export const LegalsWizard = (props) => {
    const { requiredList } = props;

    const pop = usePopSelf();

    const legalSigns = [];
    const content = requiredList?.map((signRow) => {
        const { requireSign, legal } = signRow;
        if (!requireSign) { return; }
        legalSigns.push(legal.id);
        return <LegalSlide key={legal.path} {...signRow}/>;
    });

    return (
        <Wizard
            className="LegalsWizard" 
            children={content}
            onCancel={_=>pop.down()}
            onComplete={_=>pop.down(legalSigns)}
            direction={"toDown"}
        />
    )
}

